export class CheckboxlistPoco {
    constructor(public label: string, public valeur: string, public selectionne: boolean = false, public css: string = 'gridspan4') {}
}
